import sourceSnapshot from
  "../../data/overrides/traffic/vilnius-traffic-signals.json" with {
    type: "json",
  };

import type { LocalHorizontal } from "./coordinates.ts";
import type { RuntimeWorldTilePayloadV2 } from "./schema/runtimeTile.ts";

export interface VilniusTrafficSignalSource {
  readonly id: string;
  readonly osmNodeId: number;
  readonly wgs84: Readonly<{
    latitude: number;
    longitude: number;
  }>;
  readonly lks94: Readonly<{
    easting: number;
    northing: number;
  }>;
  readonly direction?: string;
}

export interface TileTrafficSignalSource extends VilniusTrafficSignalSource {
  /** Metres relative to the owning tile origin. */
  readonly position: LocalHorizontal;
}

interface TrafficSignalSnapshot {
  readonly schemaVersion: number;
  readonly signalCount: number;
  readonly signals: readonly VilniusTrafficSignalSource[];
}

const snapshot = sourceSnapshot as TrafficSignalSnapshot;

if (
  snapshot.schemaVersion !== 1 ||
  snapshot.signalCount !== snapshot.signals.length
) {
  throw new Error("Invalid Vilnius traffic-signal source snapshot");
}

export const VILNIUS_TRAFFIC_SIGNAL_SOURCES:
  readonly Readonly<VilniusTrafficSignalSource>[] = Object.freeze(
    snapshot.signals.map((signal) => Object.freeze(signal)),
  );

export function trafficSignalSourcesForTile(
  tile: Readonly<RuntimeWorldTilePayloadV2>,
): readonly Readonly<TileTrafficSignalSource>[] {
  const origin = tile.localOriginLks94;
  return VILNIUS_TRAFFIC_SIGNAL_SOURCES.flatMap((signal) => {
    const globalX = signal.lks94.easting - origin.easting;
    const globalZ = origin.northing - signal.lks94.northing;
    if (
      globalX < tile.bounds.minX ||
      globalX >= tile.bounds.maxX ||
      globalZ < tile.bounds.minZ ||
      globalZ >= tile.bounds.maxZ
    ) {
      return [];
    }
    return [{
      ...signal,
      position: {
        x: globalX - tile.origin.x,
        z: globalZ - tile.origin.z,
      },
    }];
  });
}
